import { forwardRef } from "react";

import {
  classNames,
  inputThemeDefaultClassName,
  inputThemeTextClassName,
} from "@helpers/css";

type LabelProps = {
  label: string;
  name?: string;
  className?: string;
};

type Props = React.InputHTMLAttributes<HTMLInputElement> & {
  testId?: string;
  className?: string;
  autocomplete?: string;
  label?: string;
  name?: string;
  theme?: InputTheme;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
};

export const InputLabel = ({
  name = "",
  label,
  className = "",
}: LabelProps) => (
  <label
    htmlFor={name}
    className={classNames("block text-sm font-medium text-gray-700", className)}
  >
    {label}
  </label>
);

export enum InputTheme {
  default = "default",
  text = "text",
}

const Input = forwardRef<HTMLInputElement, Props>(
  (
    {
      autocomplete = "",
      label,
      name,
      testId = "",
      onChange,
      className,
      disabled,
      theme = InputTheme.default,
      ...restProps
    },
    ref
  ) => {
    const input = (
      <input
        id={name}
        ref={ref}
        data-testid={testId}
        autoComplete={autocomplete}
        onChange={onChange}
        disabled={disabled}
        className={classNames(
          theme === InputTheme.default && inputThemeDefaultClassName,
          theme === InputTheme.text && inputThemeTextClassName,
          className
        )}
        {...restProps}
      />
    );
    if (!label) {
      return input;
    }
    return (
      <div>
        <label
          htmlFor={name}
          className="block text-sm font-medium text-gray-700"
        >
          {label}
        </label>
        <div className={classNames(label ? "mt-1" : "")}>{input}</div>
      </div>
    );
  }
);

export default Input;
